import React, { useState, useEffect } from "react";
import ChatPanel from "./section/chatPanel/chatPanel.component";
import SourcesPanel from "./section/SourcesPanel/SourcesPanel.component";
import { message, Tabs, Grid } from "antd";
import { fetch_docs } from "./hook/fetchdata";
import "./KbSetupComponent.css";

const { useBreakpoint } = Grid;

const KbSetupComponent = () => {
  const [subsources, setSubSources] = useState([]);
  const [selectedAssistantIndex, setSelectedAssistantIndex] = useState(null);
  const [defaultSources, setDefaultSources] = useState([]);
  const [sourceFilter, setSourceFilter] = useState(null);
  const [filtersTOC, setFiltersTOC] = useState(null);
  const [offsetValue, setOffsetValue] = useState(null);
  const [sourcesLoading, setSourcesLoading] = useState(false);
  const [highlight, setHighlight] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [currentItemCount, setCurrentItemCount] = useState(0);
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [activeMobileTab, setActiveMobileTab] = useState("fact-check");
  useEffect(() => {
    if (!subsources.sentence || subsources.sentence.length === 0) {
      setHighlight(false);
    }
  }, [subsources.sentence]);

  useEffect(() => {
    fetchDefaultSources();
  }, []);

  useEffect(() => {
    if (sourceFilter) {
      fetchDefaultSources(offsetValue, sourceFilter, false);
    }
  }, [sourceFilter, offsetValue]);

  useEffect(() => {
    if (!isMobile) {
      setActiveMobileTab("fact-check");
    }
  }, [isMobile]);

  const fetchDefaultSources = async (offsetValue, sourceFilter, isRefresh = false) => {
    setSourcesLoading(true);
    try {
      // If this is a refresh (after edit/delete), reset pagination state
      const actualOffsetValue = isRefresh ? null : offsetValue;

      const response = await fetch_docs(actualOffsetValue, sourceFilter);
      const newSources = response?.response ?? [];
      setDefaultSources(newSources);
      setSubSources(newSources);
      setOffsetValue(response?.next_offset);
      setHasMore(response?.has_more ?? (response?.next_offset !== null));
      setCurrentItemCount(newSources.length);
    } catch (error) {
      console.error("Error fetching default sources:", error);
      message.error("Failed to load default sources");
    } finally {
      setSourcesLoading(false);
    }
  };

  // New function to update a specific item without refetching everything
  const updateSourceInList = (updatedSource) => {
    setDefaultSources(prevSources =>
      prevSources.map(source =>
        source.id_ === updatedSource.id_ ? updatedSource : source
      )
    );
    setSubSources(prevSources =>
      prevSources.map(source =>
        source.id_ === updatedSource.id_ ? updatedSource : source
      )
    );
  };

  const handleAssistantMessageClick = (index, sources) => {
    if (selectedAssistantIndex === index) {
      setSelectedAssistantIndex(null);
      setSubSources(defaultSources);
      setHighlight((prev) => !prev);
    } else {
      setSelectedAssistantIndex(index);
      setSubSources(sources);
      setHighlight(true);
      if (isMobile) {
        setActiveMobileTab("source-map");
      }
    }
  };

  const handleClearChat = () => {
    setSelectedAssistantIndex(null);
    setSubSources(defaultSources);
    message.success("Facts Cleared");
    if (isMobile) {
      setActiveMobileTab("fact-check");
    }
  };

  const chatPanel = (
    <div className="kb-setup-panel kb-setup-panel--chat">
      <ChatPanel
        onClearChat={handleClearChat}
        onAssistantMessageClick={handleAssistantMessageClick}
        selectedAssistantIndex={selectedAssistantIndex}
        setHighlight={setHighlight}
      />
    </div>
  );

  const sourcesPanel = (
    <div className="kb-setup-panel kb-setup-panel--sources">
      <SourcesPanel
        setHighlight={setHighlight}
        highlight={highlight}
        sourcesLoading={sourcesLoading}
        fetchDefaultSources={fetchDefaultSources}
        updateSourceInList={updateSourceInList}
        sources={subsources}
        onBackToDefault={() => {
          setSubSources(defaultSources);
          setSelectedAssistantIndex(null);
        }}
        isSubsourcesView={selectedAssistantIndex !== null}
        setSourceFilter={setSourceFilter}
        defaultSources={defaultSources}
        setDefaultSources={setDefaultSources}
        offsetValue={offsetValue}
        sourceFilter={sourceFilter}
        setSubSources={setSubSources}
        setOffsetValue={setOffsetValue}
        filtersTOC={filtersTOC}
        setFiltersTOC={setFiltersTOC}
        hasMore={hasMore}
        setHasMore={setHasMore}
        currentItemCount={currentItemCount}
        setCurrentItemCount={setCurrentItemCount}
      />
    </div>
  );

  return (
    <div className={`kb-setup ${isMobile ? "kb-setup--mobile" : ""}`}>
      {isMobile ? (
        <Tabs
          className="kb-setup-tabs"
          activeKey={activeMobileTab}
          onChange={setActiveMobileTab}
          items={[
            {
              key: "fact-check",
              label: "Fact Check",
              children: (
                <div className="kb-setup-tab-pane">
                  {chatPanel}
                </div>
              ),
            },
            {
              key: "source-map",
              label: "Source Map",
              children: (
                <div className="kb-setup-tab-pane">
                  {sourcesPanel}
                </div>
              ),
            },
          ]}
        />
      ) : (
        <div className="kb-setup-panels">
          {chatPanel}
          {sourcesPanel}
        </div>
      )}
    </div>
  );
};

export default KbSetupComponent;
